import { render, staticRenderFns } from "./SalaryApprovedDetailDialog.vue?vue&type=template&id=b22318f2&scoped=true"
import script from "./SalaryApprovedDetailDialog.vue?vue&type=script&lang=js"
export * from "./SalaryApprovedDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./SalaryApprovedDetailDialog.vue?vue&type=style&index=0&id=b22318f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22318f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b22318f2')) {
      api.createRecord('b22318f2', component.options)
    } else {
      api.reload('b22318f2', component.options)
    }
    module.hot.accept("./SalaryApprovedDetailDialog.vue?vue&type=template&id=b22318f2&scoped=true", function () {
      api.rerender('b22318f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/SalaryApprovedDetailDialog.vue"
export default component.exports